import(/* webpackMode: "eager" */ "/app/src/app/parliament/page.tsx");
